import {useEffect} from 'react'
import config from "../../../config";
import {generateNonce} from "../../../lib/Util";
import {Base64} from "js-base64";

const AzureLogin = () => {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        // 구분자(_)로 나눠져있는 state와 requestId를 복호화
        const state = params.get('data')
            ? JSON.stringify(
                (([state, requestId]) => ({ state, requestId }))
                (Base64.decode(params.get('data')).split('_'))
            )
            : params.get('url') || null;

        const nonce = generateNonce();

        window.location.href = `https://login.microsoftonline.com/${config.AZURE_TENANT}/oauth2/v2.0/authorize`
            + `?client_id=${config.AZURE_CLIENT_ID}`
            + `&redirect_uri=${encodeURIComponent(config.AZURE_REDIRECT_URI)}`
            + `&response_type=code`
            + `&response_mode=query`
            + `&scope=User.Read`
            +  (state ? `&state=${encodeURIComponent(state)}` : '')
            + `&nonce=${nonce}`;
    }, [])
}

export default AzureLogin